<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <iframe :src="embedUrl" style="width: 100%; height: 100vh;"></iframe>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast);
export default {
  name: "RebootReport",
  data() {
    return {
      embedUrl: '',
    };
  },
  created() {
    this.getRebootReport();
  },
  methods: {
    async getRebootReport() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.REPORTS_SERVICE + `/tenants/${config.LOOKER_TENANT}/looker/embed-url`;
      var rebootReport = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: "include",
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          "report_name": "Reboot Report",
          "index_id": 12,
          "isDefault": true,
          "icon": "icon-rounding",
          "isLookerReportType": true,
          "report_url": config.REBOOT_REPORT,
          "name": "Reboot Report",
          "value": 12
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "content-type": "application/json",
        },
      });
      try {
        var rebootReportResponse = await fetch(rebootReport);
        if (rebootReportResponse.status == 503) {
          return this.getRebootReport();
        } else {
          let data = await rebootReportResponse.json();
          this.embedUrl = `${data.url}`;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>


